/*
 * A.L.M — variant reachability fix. 2026-10-03.
 *
 * THE BUG
 * -------
 * assets/am-core.js disables an option value whenever no AVAILABLE variant
 * matches that value together with every other option the shopper currently
 * has selected. On a product whose variant matrix is complete that is fine.
 * On a sparse matrix it traps the shopper: to reach "White / AU plug" they
 * must pass through "White / US plug" or "Black / AU plug", and if neither
 * of those exists, both buttons are disabled and the variant can never be
 * selected. On the Portable Mini Home Projector that left 10 of 11 variants
 * unbuyable; on the Foldable LED Night Light, 4 of 17.
 *
 * THE FIX
 * -------
 * Two small corrections layered on top of am-core.js. am-core.js itself is
 * NOT modified — it still owns price, media, the stock line, the add-to-cart
 * button and the sticky bar.
 *
 *   1. SNAP (capture phase, so it runs before am-core reads the form).
 *      When the shopper picks a value whose combination does not exist, move
 *      the OTHER options to the closest combination that does exist and keeps
 *      their pick. This is what a correct picker does: one click always lands
 *      on a real variant instead of a dead end.
 *
 *   2. UNLOCK (after am-core has run).
 *      Because of 1, every value that appears in at least one AVAILABLE
 *      variant is now reachable in a single click, so none of them may stay
 *      disabled. Re-enable exactly that set — nothing more.
 *
 * WHAT THIS DOES NOT DO
 * ---------------------
 * It never invents stock and never makes a sold-out variant look buyable.
 * `reachable` is built only from variants Shopify reports as available, so a
 * value that exists only in sold-out variants stays disabled, and a
 * combination that exists but is sold out still shows "Sold out". Only the
 * false negatives are removed.
 */
(function () {
  'use strict';

  function boot() {
    var tag = document.querySelector('[data-am-variants]');
    if (!tag) return;

    var data;
    try { data = JSON.parse(tag.textContent); } catch (e) { return; }
    if (!data || data.length < 2 || !data[0].options) return;

    var nOpt = data[0].options.length;
    if (!nOpt) return;

    function inputs() {
      return Array.prototype.slice.call(document.querySelectorAll('[data-am-opt]'));
    }
    function pos(el) {
      return (+el.getAttribute('data-am-opt')) - 1;
    }
    function selection() {
      var sel = new Array(nOpt);
      inputs().forEach(function (i) {
        if (i.type === 'hidden' || i.checked) sel[pos(i)] = i.value;
      });
      return sel;
    }
    function exact(sel) {
      for (var i = 0; i < data.length; i++) {
        var v = data[i], hit = true;
        for (var j = 0; j < nOpt; j++) {
          if (v.options[j] !== sel[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }
    /* Closest real variant that keeps `value` at position `p`.
       +2 for every other option the shopper already chose, +1 if in stock. */
    function resolve(sel, p, value) {
      var best = null, bestScore = -1;
      for (var i = 0; i < data.length; i++) {
        var v = data[i];
        if (v.options[p] !== value) continue;
        var score = v.available ? 1 : 0;
        for (var j = 0; j < nOpt; j++) {
          if (j !== p && v.options[j] === sel[j]) score += 2;
        }
        if (score > bestScore) { bestScore = score; best = v; }
      }
      return best;
    }
    function apply(v) {
      inputs().forEach(function (i) {
        var want = v.options[pos(i)];
        if (i.type === 'hidden') i.value = want;
        else i.checked = (i.value === want);
      });
    }

    /* Values that at least one in-stock variant actually offers. */
    var reachable = [];
    for (var j = 0; j < nOpt; j++) reachable.push({});
    data.forEach(function (v) {
      if (!v.available) return;
      for (var k = 0; k < nOpt; k++) reachable[k][v.options[k]] = true;
    });

    function unlock() {
      inputs().forEach(function (i) {
        if (i.type === 'hidden') return;
        if (reachable[pos(i)][i.value]) i.disabled = false;
      });
    }

    var repairing = false;

    document.addEventListener('change', function (ev) {
      var el = ev.target;
      if (!el || !el.hasAttribute || !el.hasAttribute('data-am-opt')) return;
      if (repairing) return;

      var p = pos(el), value = el.value;

      if (!exact(selection())) {
        var v = resolve(selection(), p, value);
        if (v) apply(v);
      }

      /* Safety net: if the theme's own handler happened to run first, the
         form may still hold a combination that does not exist. Correct it
         and let am-core recompute from the corrected form. */
      setTimeout(function () {
        if (!exact(selection())) {
          var v2 = resolve(selection(), p, value);
          if (v2) {
            apply(v2);
            var again = inputs().filter(function (i) {
              return i.type !== 'hidden' && i.checked && pos(i) === p;
            })[0];
            if (again) {
              repairing = true;
              again.dispatchEvent(new Event('change', { bubbles: true }));
              repairing = false;
            }
          }
        }
        unlock();
      }, 0);
    }, true);

    unlock();
    setTimeout(unlock, 0);
    setTimeout(unlock, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
